export default __webpack_public_path__ + "static/media/alejandroG.82ccacc4.jpg";